import React from 'react'
import { Control } from 'react-redux-form'
import { Checkbox, CheckboxProps } from 'components/styled/checkbox'
import { Optional } from 'type-utils'
import { useStore } from 'react-redux'

interface ControlCheckboxProps {
  model: string
  componentProps: Optional<CheckboxProps, 'onChange'>
  validators?: any
  validateOn?: any
}

export const CheckboxComponent = ({
  componentProps,
  onChange,
  value,
}: {
  componentProps: Optional<CheckboxProps, 'onChange'>
  onChange: (newValue: boolean) => void
  value: boolean
}) => {
  /* Custom onChange function and value can be given to the checkbox component. If the custom onChange function (componentProps.onChange) function or value (componentProps.value) is not given, react-redux-form onChange and value will be used (Control-component passes those props to this component).
   */
  const onChangeFunction = componentProps.onChange || onChange
  const checkboxValue =
    componentProps.value !== undefined ? componentProps.value : value

  return (
    <Checkbox
      {...componentProps}
      value={checkboxValue}
      onChange={value => onChangeFunction(value)}
    />
  )
}

export const ControlCheckbox = ({
  componentProps,
  model,
  validators,
  validateOn = 'change',
  ...props
}: ControlCheckboxProps) => {
  const store = useStore()
  return (
    <Control
      {...props}
      // @ts-ignore
      store={store}
      model={model}
      validateOn={validateOn}
      validators={validators}
      component={CheckboxComponent}
      //  By default, any props on <Control> that are not part of the Control.propTypes will be passed down to the custom component.
      // @ts-ignore
      componentProps={componentProps}
    />
  )
}
